import { LearningItemsAPI, LearningItemsResponsesAPI } from "@/lib/api"
import {
  SET_LEARNING_ITEMS,
  ADD_LEARNING_ITEM,
  DELETE_LEARNING_ITEM,
  UPDATE_LEARNING_ITEM,
  ADD_LEARNING_ITEM_RESPONSE,
  DELETE_LEARNING_ITEM_RESPONSE,
  UPDATE_LEARNING_ITEM_RESPONSE
} from "@/store/mutationTypes"

const state = {
  all: []
}

// getters
const getters = {
  getLearningItems: state => state.all,
  getTemplates: state => state.all.filter(el => el.template),
  getLearningItemById: state => id => {
    return state.all.find(el => el.id === parseInt(id))
  },
  getLearningItemsByUserId: state => id => {
    return state.all.filter(el => el.user_id === id)
  },
  getLearningItemsByParentId: state => id => {
    return state.all.filter(el => el.parent_id === id)
  }
}

// actions
const actions = {
  loadLearningItem: async function({ commit }, id) {
    console.log("in store: " + id)
    LearningItemsAPI.get(id).then(learningItem => {
      commit(SET_LEARNING_ITEMS, [learningItem])
    })
  },
  loadLearningItems: async function({ commit }, payload) {
    Promise.all([
      LearningItemsAPI.list({
        templates: false,
        includeHidden: true
      }),
      LearningItemsAPI.list({
        templates: true,
        includeHidden: true
      })
    ]).then(responses => {
      commit(SET_LEARNING_ITEMS, responses.flat())
    })
  },
  async addLearningItem(
    { commit, dispatch },
    { name, description, body, badgeId }
  ) {
    let newItem = await LearningItemsAPI.create({
      name,
      description,
      body,
      badgeId
    })
    commit(ADD_LEARNING_ITEM, newItem)
    await dispatch("loadLearningItems")
    return newItem
  },
  async updateLearningItem(
    { commit, dispatch },
    { id, body, description, name, hidden, status, badgeId }
  ) {
    commit(
      UPDATE_LEARNING_ITEM,
      await LearningItemsAPI.update(id, {
        name,
        description,
        body,
        hidden,
        status,
        badgeId
      })
    )
    await dispatch("loadLearningItems")
  },
  async deleteLearningItem({ commit, dispatch }, itemId) {
    commit(DELETE_LEARNING_ITEM, await LearningItemsAPI.delete(itemId))
    await dispatch("loadLearningItems")
  },
  async addLearningItemResponse(
    { commit, dispatch },
    { itemId, options, key }
  ) {
    commit(
      ADD_LEARNING_ITEM_RESPONSE,
      await LearningItemsResponsesAPI.create(itemId, options, key)
    )
    await dispatch("loadLearningItems")
  },
  async updateLearningItemResponse(
    { commit, dispatch },
    { id, learningItemId, key, value, type, options }
  ) {
    commit(
      UPDATE_LEARNING_ITEM_RESPONSE,
      await LearningItemsResponsesAPI.update(id, {
        learningItemId,
        key,
        value,
        type,
        options
      })
    )
    await dispatch("loadLearningItems")
  },
  async deleteLearningItemResponse({ commit, dispatch }, itemId) {
    commit(
      DELETE_LEARNING_ITEM_RESPONSE,
      await LearningItemsResponsesAPI.delete(itemId)
    )
    await dispatch("loadLearningItems")
  }
}

// mutations
const mutations = {
  [SET_LEARNING_ITEMS](state, learningItems) {
    state.all = learningItems
  },
  [ADD_LEARNING_ITEM](state, learningItem) {
    state.all.push(learningItem)
  },
  [ADD_LEARNING_ITEM_RESPONSE](state, response) {},
  [UPDATE_LEARNING_ITEM](state, learningItem) {
    let learningItemToUpdate = state.all.find(el => learningItem.id === el.id)
    learningItemToUpdate = learningItem
  },
  [UPDATE_LEARNING_ITEM_RESPONSE](state, response) {},
  [DELETE_LEARNING_ITEM](state, learningItemId) {
    let index = state.all.findIndex(el => el.id === learningItemId)
    state.all.splice(index, 1)
  },
  [DELETE_LEARNING_ITEM_RESPONSE](state, response) {},
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
